var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3335 5.50001C18.3335 4.99375 17.9231 4.58334 17.4168 4.58334H16.5002C15.9939 4.58334 15.5835 4.99375 15.5835 5.50001V16.5C15.5835 17.0063 15.9939 17.4167 16.5002 17.4167H17.4168C17.9231 17.4167 18.3335 17.0063 18.3335 16.5V5.50001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 10.5417C3.66667 10.0354 4.07706 9.625 4.58333 9.625H10.0833C10.5896 9.625 11 10.0354 11 10.5417V11.4583C11 11.9646 10.5896 12.375 10.0833 12.375H4.58333C4.07706 12.375 3.66667 11.9646 3.66667 11.4583V10.5417Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.03237 6.28241C8.74362 5.99368 8.24991 6.19817 8.24991 6.6065V15.3935C8.24991 15.8018 8.74362 16.0063 9.03237 15.7175L13.4258 11.3241C13.6048 11.1451 13.6048 10.8549 13.4258 10.6759L9.03237 6.28241Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame34);
export default __webpack_public_path__ + "static/media/Frame (34).ccba7bcdd67c5fa544f15d3df5ed121a.svg";
export { ForwardRef as ReactComponent };